exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-preview{width:350px;height:300px}.down-button-position{position:absolute;right:20px}.padding-bottom-20px{padding-bottom:15px}#modal-center1 .modal-header{display:none!important}", ""]);

// exports
